"use client";
import { motion } from "framer-motion";

export default function AnimatedIntro() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="space-y-6 text-center"
    >
      <h1 className="font-serif text-4xl md:text-5xl font-light tracking-tight bg-linear-to-r from-neutral-800 via-neutral-600 to-neutral-400 dark:from-neutral-50 dark:via-neutral-300 dark:to-neutral-500 bg-clip-text text-transparent">
        Contact Us
      </h1>
      <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
        Have a project in mind or need guidance on Concretta microcement? Reach
        out and our team will respond within one business day.
      </p>
    </motion.div>
  );
}
